import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

export interface LastViewedItem {
    id: string;
    lastViewedAt: number;
}

export class LastViewedUtils {
    static getLastViewedProjects(): LastViewedItem[] {
        const lastViewed = localStorageUtil.get<LastViewedItem[]>(ELocalStorageKeys.LAST_VIEWED_PROJECTS);
        return lastViewed || [];
    }

    static addLastViewedProject(projectId: string): void {
        const lastViewed = this.getLastViewedProjects();
        const now = Date.now();

        const filteredItems = lastViewed.filter(item => item.id !== projectId);
        const updatedItems = [{ id: projectId, lastViewedAt: now }, ...filteredItems];
        const limitedItems = updatedItems.slice(0, 50);

        localStorageUtil.set(ELocalStorageKeys.LAST_VIEWED_PROJECTS, limitedItems);
    }

    static getProjectLastViewedAt(projectId: string): number | null {
        const lastViewed = this.getLastViewedProjects();
        const item = lastViewed.find(item => item.id === projectId);
        return item ? item.lastViewedAt : null;
    }

    static clearLastViewedProjects(): void {
        localStorageUtil.remove(ELocalStorageKeys.LAST_VIEWED_PROJECTS);
    }
}

